import React, { useEffect, useState } from "react";
import { Breadcrumb, Spin, Tabs } from "antd";
import Information from "./Information";
import { useNavigate, useParams } from "react-router-dom";
import Documents from "./Documents";
import Notes from "./Notes";
import Files from "./Files";
import { GetClientByIdApi } from "../../../api/request/clients/clients";
import Activity from "./Activity";
import Overview from "./Overview";
import Invoice from "./Invoice";
import Signature from "./Signature";

const ClientDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [client, setClient] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState({ id: "1", title: "Overview" });
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);

  const tabs = [
    { key: "1", label: "Overview" },
    { key: "2", label: "Information" },
    { key: "3", label: "Documents" },
    { key: "4", label: "Files" },
    { key: "5", label: "Invoice" },
    { key: "6", label: "Signature" },
    { key: "7", label: "Activity" },
    { key: "8", label: "Notes" },
  ];

  const getClientDetails = async () => {
    if (!id) return;
    try {
      setIsLoading(true);
      let params = { id: id };
      const { data } = await GetClientByIdApi(params);
      if (data?.status) {
        setClient(data?.data);
        setBreadcrumbItems([
          {
            title: (
              <p
                className="cursor-pointer font-semibold text-black"
                onClick={() => navigate("/clients")}
              >
                Clients
              </p>
            ),
          },
          { title: <p className="capitalize">{data?.data?.name}</p> },
          { title: <p className="capitalize">{activeTab?.title}</p> },
        ]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getClientDetails();
  }, [id]);

  const changeTab = (tab) => {
    setActiveTab(tab);
    setBreadcrumbItems((current) => [
      ...current?.slice(0, 2),
      { title: <p className="capitalize">{tab?.title}</p> },
    ]);
  };

  const renderTab = () => {
    switch (activeTab?.id) {
      case "1":
        return <Overview changeTab={changeTab} />;
      case "2":
        return <Information client={client} setClient={setClient} />;
      case "3":
        return <Documents id={id} tab={activeTab} />;
      case "4":
        return <Files id={id} tab={activeTab} />;
      case "5":
        return <Invoice client={client} />;
      case "6":
        return <Signature id={id} />;
      case "7":
        return <Activity id={id} />;
      case "8":
        return <Notes client={client} />;
      default:
        return (
          <div className="flex items-center justify-center h-full text-secondaryLight1">
            Select a tab
          </div>
        );
    }
  };

  return (
    <div>
      {isLoading ? (
        <div className="flex flex-col items-center gap-2 mt-48">
          <Spin />
          <p className="text-secondaryLight1">Loading...</p>
        </div>
      ) : (
        <>
          <Breadcrumb items={breadcrumbItems} />
          <div className="pt-5">
            <Tabs
              activeKey={activeTab.id}
              onChange={(key) => {
                const tab = tabs.find((t) => t.key === key);
                if (tab) changeTab({ id: tab.key, title: tab.label });
              }}
              items={tabs}
            ></Tabs>
          </div>
          <div className="md:col-span-5 bg-white border rounded-lg relative overflow-x-auto">
            {renderTab()}
          </div>
        </>
      )}
    </div>
  );
};

export default ClientDetails;
